import { CookiesEnum as e } from "../cookies/cookies-enum.mjs";
import { StorageKey as t } from "./storage-key.mjs";
import { useStorage as n } from "./use-storage.mjs";
import { useEffect as r } from "react";
import i from "js-cookie";
import a from "md5";
//#region src/storage/use-session-store.ts
var o = (e) => e ? `${t.SessionStorePrefix}${e}:` : t.SessionStorePrefix, s = (t, { namespace: n, userContextKey: r } = {}) => {
	let s = r ?? i.get(e.UserContextKey);
	return `${o(n)}${s ? a(s) : "shared"}:${t}`;
}, c = (t) => t ? `${e.BrowserSessionActiveId}_${t}` : e.BrowserSessionActiveId, l = (e, t) => i.get(t) === e, u = (t) => {
	r(() => {
		t && i.set(e.UserContextKey, t, {
			path: "/",
			secure: !0,
			sameSite: "strict"
		});
	}, [t]);
}, d = (t, a = {}) => {
	let { namespace: u, userContextKey: d, ...f } = a, p = d ?? i.get(e.UserContextKey), m = p ?? "shared", h = o(u), g = c(u), _ = s(t, {
		namespace: u,
		userContextKey: p
	}), v = n(_, f);
	if (r(() => {
		l(m, g) || (v.removeByPrefix(h), i.set(g, m, {
			sameSite: "strict",
			path: "/"
		}));
	}, [
		g,
		v.removeByPrefix,
		m,
		h
	]), !u) return v;
	let y = () => l(m, g) ? v.getItem() : null;
	return {
		...v,
		getItem: y
	};
};
//#endregion
export { s as getSessionStoreKey, u as useExtendSessionId, d as useSessionStore };
